import TransactionModal from "./transactionModal.js";
import { $_GET } from "../globalFunctions.js";

export default class DecreaseSharesModal extends TransactionModal {
  constructor(companyId) {
    super("decrease-shares-modal", companyId);

    this.$date = this.$form.querySelector('[name="date"]');
    this.$availableShares = this.$form.querySelector("[data-available-shares]");
    this.$amount = this.$form.querySelector('[name="amount"]');
    this.$stakeholder = this.$form.querySelector('[name="stakeholder"]');
    this.$shareClass = this.$form.querySelector('[name="share-class"]');

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "stakeholder",
        varType: "int",
        required: true,
        trigger: "change",
      },
      {
        name: "beneficiary",
        varType: "int",
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "amount",
        varType: "int",
        required: true,
      },
      {
        name: "share_class",
        varType: "int",
        required: true,
      },
      {
        name: "numeration",
        varType: "string",
        mayNotExist: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    this.setupForm();

    Promise.all([
      this.documentsPromise,
      this.setupStakeholders(),
      this.setupShareClasses(),
    ]).then(() => {
      this.whenReady();
      this.updateAvailableSharesCount();
    });
  }

  whenReady() {
    if (this.prefillData) {
      this.prefillData.amount = Math.abs(this.prefillData.amount);
    }
    super.whenReady();
  }

  setupForm() {
    this.$form.querySelector('[name="date"]').valueAsDate = new Date();

    this.$stakeholder.addEventListener("change", () => {
      this.updateAvailableSharesCount();
    });
    this.$date.addEventListener("change", () => {
      this.updateAvailableSharesCount();
    });
    this.$shareClass.addEventListener("change", () => {
      this.updateAvailableSharesCount();
    });

    this.$amount.addEventListener("input", () => {
      if (this.getInt("amount") > this.$amount.max) {
        this.setInt("amount", this.$amount.max);
      }
    });

    this.$form
      .querySelector('[data-action="autocomplete-numeration"]')
      ?.addEventListener("click", () => {
        this.autocompleteNumeration();
      });
  }

  autocompleteNumeration() {
    const amount = this.getInt("amount");

    if (amount < 1) {
      this.showErrorOnField("", this.$form.querySelector('[name="amount"]'));
      return;
    }

    this.getLatestNumeration().then((numeration) => {
      let start = numeration + 1;
      let end = start + amount - 1;
      this.$form.querySelector('[name="numeration"]').value = [start, end].join(
        "-"
      );
    });
  }

  updateAvailableSharesCount() {
    this.getSharesCount(
      this.$stakeholder.value,
      peque.SHARE_RECEIVER_TYPE_STAKEHOLDER,
      this.$date.value,
      this.$shareClass.value
    ).then((count) => {
      this.$availableShares.querySelector("i").innerText =
        peque.formatNumber(count);
      this.$amount.max = count;
    });
  }

  getSharesCount(receiverId, receiverType, date, shareClass) {
    return new Promise((resolve, reject) => {
      receiverId = parseInt(receiverId);
      receiverType = parseInt(receiverType);
      shareClass = parseInt(shareClass);

      // it's missing data, do nothing, not even rejecting the promise
      if (date.length < 1 || isNaN(shareClass)) {
        return;
      }

      peque
        .api(
          "shares/count",
          {
            receiver_id: receiverId,
            receiver_type: receiverType,
            date: date,
            class: shareClass,
            simulation: $_GET("simulation"),
          },
          "get"
        )
        .then((response) => {
          let amount = response.result;

          // sum current value as available if it's the same stakeholder
          if (this.currentData && receiverId === this.currentData.stakeholder) {
            amount += Math.abs(this.currentData.amount);
          }

          resolve(amount);
        });
    });
  }

  validateNumeration(numeration, amount) {
    if (!numeration || numeration.length < 1) {
      return true;
    }

    if (!numeration.includes("-")) {
      return false;
    }

    const split = numeration.split("-");

    if (split.length !== 2) {
      return false;
    }
    split[0] = parseInt(split[0]);
    split[1] = parseInt(split[1]);

    if (
      split[0] < 1 ||
      split[1] < 1 ||
      split[1] < split[0] ||
      split[0] === split[1] ||
      split[1] - split[0] !== amount ||
      split.join("-") !== numeration
    ) {
      return false;
    }

    return true;
  }

  validateAndSendForm() {
    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = peque.TRANSACTION_TYPE_DECREASE_SHARES;

        if (!this.validateNumeration(data.numeration, data.amount)) {
          this.showErrorOnField(
            "Invalid format or value",
            this.$form.querySelector('[name="numeration"]')
          );
          return;
        }

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            this.mutateReactTransactions();
          });
      })
      .catch((error) => {
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
